<template>
<b-card class="card-1 m-t-10" v-show="showFilter">
  <div class="b-card-body">
    <b-row class="m-b-30">
      <b-col cols="6">

        <b-form-group id="field-start" label-cols-sm="3" label-cols-lg="2" description="Start date for create" label="Start" label-for="created_start">
          <b-form-datepicker id="created_start" v-model="created_start" class="mb-2" @input="end_disabled = false; broadcastDate()"></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col cols="6">

        <b-form-group id="field-end" label-cols-sm="3" label-cols-lg="2" description="End date for create" label="End" label-for="created_end">
          <b-form-datepicker id="created_end" :disabled="end_disabled" v-model="created_end" class="mb-2" :min="created_start" @input="broadcastDate()"></b-form-datepicker>
        </b-form-group>
      </b-col>

    </b-row>

    <b-row class="m-b-30">
      <b-col md="4">
        <label for="">Shipping Service</label>
        <b-form-select v-model="selected" @change="broadcastDate()" :options="options"></b-form-select>
      </b-col>
      <b-col md="4">
         <label for="">Conversion source</label>
         <b-form-input class="conversionSrc" size="md" v-model="conversionSource" placeholder="Source Name" @change="broadcastDate()"></b-form-input>
      </b-col>
    </b-row>

    <div>
      <b-link href="#foo" @click="resetAdvanced">
        <b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise> Reset Advanced Filters
      </b-link>
    </div>

  </div>
</b-card>
</template>

<script>
import EventBus from '../../EventBus';
export default {
  data() {
    return {
      created_start: '',
      created_end: '',
      end_disabled: true,
      selected: null,
      options: [{
          value: null,
          text: 'Select Type'
        },
        {
          value: 'express',
          text: 'Express Royal Delivery'
        },
        {
          value: 'free',
          text: 'Free Delivery'
        },
        {
          value: 'all',
          text: 'All'
        },
      ],
      conversionSource: ''
    }
  },
  props: {
    showFilter: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    broadcastDate() {

      EventBus.$emit('order-advanced-filter-changed', {
        created_start_date: this.created_start,
        created_end_date: this.created_end,
        shipping_type: this.selected,
        conversion_source: this.conversionSource
      });

    },
    resetAdvanced() {
      this.created_start = '';
      this.created_end = '';
      this.selected = null;
      this.conversionSource = '';
      this.broadcastDate();
    },
  
  }
}
</script>

<style lang="scss" scoped>
  .conversionSrc{
    height: 38px;
    border-radius: 5px;
    font-size: 14px;
  }
</style>
